import { Certificate, GraduationCap, Buildings, ShieldCheck } from "@phosphor-icons/react";
import { StatStrip } from "@/components/shared/StatStrip";

const ITEMS = [
  { label: "Established in 2011", icon: <Certificate size={20} weight="duotone" /> },
  { label: "Specialist Teacher Recruitment", icon: <GraduationCap size={20} weight="duotone" /> },
  { label: "School-Focused Staffing", icon: <Buildings size={20} weight="duotone" /> },
  { label: "Experienced Recruitment Support", icon: <ShieldCheck size={20} weight="duotone" /> },
];

export const TrustStrip = () => <StatStrip items={ITEMS} />;
